/**
 * Test IDs for QA automation.
 */
export const testIds = {
  receiverForecastsNavigation: "receiver-forecasts-navigation",
  receiverForecastsModels: "receiver-forecasts-models",
  receiverForecastsDashboard: "receiver-forecasts-dashboard",
} as const;
